var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleStepsIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5043_5205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 75
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5043_5205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1265 65.5469C12.0328 65.8073 11.0823 65.5339 10.275 64.7266C9.46767 63.9193 9.19423 62.9688 9.45465 61.875L12.189 48.5938L26.4078 62.8125L13.1265 65.5469ZM31.4859 58.9844L16.0171 43.5156L48.2828 11.25C49.4807 10.0521 50.9651 9.45312 52.7359 9.45312C54.5067 9.45312 55.9911 10.0521 57.189 11.25L63.7515 17.8125C64.9494 19.0104 65.5484 20.4948 65.5484 22.2656C65.5484 24.0365 64.9494 25.5208 63.7515 26.7188L31.4859 58.9844Z",
    fill: "#5144B4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleStepsIcon2);
export default __webpack_public_path__ + "static/media/SimpleStepsIcon2.455af157c36b5b67bacd796dba8f050d.svg";
export { ForwardRef as ReactComponent };